import {
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { NoOpEncoder_getInstance2wgh00a9s97su as NoOpEncoder_getInstance } from '../internal/NoOpEncoder.mjs';
import {
  encodeNotNullMark352dnk5r97tvq as encodeNotNullMark,
  beginCollection27i47rk9upjw4 as beginCollection,
  encodeSerializableValue1mu7jsn2oheqi as encodeSerializableValue,
  encodeNullableSerializableValue22qo2euy9x1r4 as encodeNullableSerializableValue,
  shouldEncodeElementDefault1vy568gzcy4z0 as shouldEncodeElementDefault,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
} from './Encoding.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractEncoderClass;
function AbstractEncoder() {
  if (AbstractEncoderClass === VOID) {
    class $ {
      static k1s() {
        return createThis(this);
      }
      r1r(descriptor) {
        return this;
      }
      s1r(descriptor) {
      }
      l1s(descriptor, index) {
        return true;
      }
      m1s(value) {
        throw SerializationException().v1o('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
      }
      n1s() {
        throw SerializationException().v1o("'null' is not supported by default");
      }
      o1s(value) {
        return this.m1s(value);
      }
      p1s(value) {
        return this.m1s(value);
      }
      q1s(value) {
        return this.m1s(value);
      }
      r1s(value) {
        return this.m1s(value);
      }
      s1s(value) {
        return this.m1s(value);
      }
      t1s(value) {
        return this.m1s(value);
      }
      u1s(value) {
        return this.m1s(value);
      }
      v1s(value) {
        return this.m1s(new (Char())(value));
      }
      w1s(value) {
        return this.m1s(value);
      }
      x1s(enumDescriptor, index) {
        return this.m1s(index);
      }
      y1s(descriptor) {
        return this;
      }
      z1s(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.o1s(value);
        }
      }
      a1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.p1s(value);
        }
      }
      b1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.q1s(value);
        }
      }
      c1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.r1s(value);
        }
      }
      d1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.s1s(value);
        }
      }
      e1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.t1s(value);
        }
      }
      f1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.u1s(value);
        }
      }
      g1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.v1s(value);
        }
      }
      h1t(descriptor, index, value) {
        if (this.l1s(descriptor, index)) {
          this.w1s(value);
        }
      }
      i1t(descriptor, index) {
        return this.l1s(descriptor, index) ? this.y1s(descriptor.d1q(index)) : NoOpEncoder_getInstance();
      }
      j1t(descriptor, index, serializer, value) {
        if (this.l1s(descriptor, index)) {
          this.k1t(serializer, value);
        }
      }
      l1t(descriptor, index, serializer, value) {
        if (this.l1s(descriptor, index)) {
          this.m1t(serializer, value);
        }
      }
    }
    protoOf($).n1t = encodeNotNullMark;
    protoOf($).o1t = beginCollection;
    protoOf($).k1t = encodeSerializableValue;
    protoOf($).m1t = encodeNullableSerializableValue;
    protoOf($).p1t = shouldEncodeElementDefault;
    initMetadataForClass($, 'AbstractEncoder', VOID, VOID, [Encoder(), CompositeEncoder()]);
    AbstractEncoderClass = $;
  }
  return AbstractEncoderClass;
}
//region block: exports
export {
  AbstractEncoder as AbstractEncoder2gxtu3xmy3f8j,
};
//endregion

//# sourceMappingURL=AbstractEncoder.mjs.map
